'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../dist-es6/client/formatters');
const BaseControllerBackedTooltip=require('../../../../../dist-es6/client/directives/tooltips/baseControllerBackedTooltip');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');let

IncidentTooltipDirective=class IncidentTooltipDirective extends BaseControllerBackedTooltip{
get bindings(){
return[
'fatigueThresholdStatus',
'deviationThresholdStatus',
'deviation',
'fatigue',
'time',
'description',
'timezone',
'incident'];

}

get templateUrl(){
return'/templates/directives/tooltips/incidentTooltip/incidentTooltipTemplate';
}

get controller(){
return IncidentTooltipDirectiveController;
}};


const scoreByStatusMap={
Above:2,
At:1,
Below:0,
NotApplicable:0};


const messageByStatusMap=new Map([
[ThresholdStatus.Above,'OVER'],
[ThresholdStatus.At,'NEAR'],
[ThresholdStatus.Below,'UNDER'],
[ThresholdStatus.NotApplicable,'UNDER']]);let


IncidentTooltipDirectiveController=class IncidentTooltipDirectiveController{
static get $inject(){
return['timeFormattingService'];
}

constructor(timeFormattingService){
this._timeFormattingService=timeFormattingService;
}

get timeString(){
return this._timeFormattingService.monthDayYearAndTimeWithZone(this.time,this.timezone);
}

get thresholdStatus(){
return this._thresholdStatus||(this._thresholdStatus=_.minBy(_.compact([this.fatigueThresholdStatus,this.deviationThresholdStatus]),s=>scoreByStatusMap[s.value]));
}

get thresholdStatusMessage(){
return this._thresholdStatusMessage||(this._thresholdStatusMessage=messageByStatusMap.get(this.thresholdStatus));
}};


module.exports=IncidentTooltipDirective;
module.exports.IncidentTooltipDirectiveController=IncidentTooltipDirectiveController;
//# sourceMappingURL=incidentTooltipDirective.js.map
